import React, { useState, useEffect } from "react";
import {  StyledBox, StyledTypo, StyledPaper } from "../StyledMui";
import { Grid, Typography, Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import useStore from "../Store";

function Hover(props) {
  const { journeyId, interactionId, logs, getLogs } = useStore((state) => state.header)
  const [ countLogs, setCountLogs] = useState({
    totalCount: 0,
    totalFail: 0,
    totalSuccess: 0,
    thisCount: 0,
    thisFail: 0,
    thisSuccess: 0
  })

  useEffect(() => {
    //setVariabledContent(variabledContents[page]);
    console.log(journeyId)
    if(journeyId !== '') getLogs()
  }, [journeyId])

  useEffect(() => {
    //setVariabledContent(variabledContents[page]);
    if(logs.length > 0) setLogs()
  }, [logs])

  const setLogs = () => {
    setCountLogs(logs.reduce((a,c) => {
        a.totalCount++
        c.resultCode && String(c.resultCode) === '1000' ? a.totalSuccess++ : a.totalFail++
        console.log(c.versionId, interactionId)
        if(c.versionId === interactionId){
            a.thisCount++
            c.resultCode && String(c.resultCode) === '1000' ? a.thisSuccess++ : a.thisFail++
        }
        return a
    },{
        totalCount: 0,
        totalFail: 0,
        totalSuccess: 0,
        thisCount: 0,
        thisFail: 0,
        thisSuccess: 0
    }))
    //console.log('count')
  }

  return (
    <>
        <StyledPaper style={{ height: "100%" }}>
            <StyledBox>
                <StyledTypo>결과보기</StyledTypo>
            </StyledBox>
            <Box sx={{ overflowX: "auto" }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3}>전체버전</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">총 요청</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.totalCount }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">성공</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.totalSuccess }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">실패</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.totalFail }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={3}>현재버전</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">총 요청</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.thisCount }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">성공</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.thisSuccess }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">실패</Typography>
                                </Box>
                            </TableCell>
                            <TableCell  item xs={false} sm={5}>
                                <Box display="flex" justifyContent="center" width="100%">
                                <Typography variant="body1">{ countLogs.thisFail }</Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
            
            
        </StyledPaper>
    </>
  );
}

export default Hover;
